export default [
  {
    path: '/publicPage/transportSubplanManagement',
    name: 'transportSubplanManagement',
    component: () => import(/* webpackChunkName: "order-center" */ '@/views/publicPage/orderManagement/transportSubPlan/IndexList.vue'),
    meta: {
      authPass: true,
      title: '运输子计划管理',
      noTitle: true,
      headerId: 'myFortune'
    }
  },
  {
    path: '/publicPage/transportSubplanManagement/transportSubplanDetail',
    name: 'transportSubplanDetail',
    component: () => import(/* webpackChunkName: "order-center" */ '@/views/publicPage/orderManagement/transportSubPlan/components/IndexInfo.vue'),
    meta: {
      authPass: true,
      title: '子计划详情',
      noTitle: true,
      headerId: 'myFortune'
    }
  },
  {
    path: '/publicPage/addTransportSubplan',
    name: 'addTransportSubplan',
    component: () => import(/* webpackChunkName: "order-center" */ '@/views/publicPage/orderManagement/transportSubPlan/addTransportSubplan.vue'),
    meta: {
      authPass: true,
      title: '新增子计划',
      noTitle: true,
      headerId: 'myFortune'
    }
  },
];
